module.exports = __webpack_public_path__ + "images/fa646ff4b209d258b1f3d7b00490915e.svg";